import { themeQuartz } from "ag-grid-community";

const INTER = "Inter, system-ui, -apple-system, sans-serif";
const MONO = "'JetBrains Mono', ui-monospace, 'SF Mono', Menlo, monospace";

/**
 * Terminal table params: Inter chrome, mono data cells, hairline borders.
 * CSS-var driven so one param set serves both schemes via tokens.css.
 */
export const agGridThemeParams = {
  fontFamily: INTER,
  headerFontFamily: INTER,
  cellFontFamily: MONO,
  fontSize: 12,
  headerFontSize: 10,
  headerFontWeight: 500,
  spacing: 4,
  cellHorizontalPaddingScale: 0.5,

  backgroundColor: "var(--pulse-card, var(--mantine-color-body))",
  foregroundColor: "var(--mantine-color-text)",
  chromeBackgroundColor: "var(--pulse-card, var(--mantine-color-body))",
  headerBackgroundColor: "var(--pulse-card, var(--mantine-color-body))",
  headerTextColor:
    "var(--pulse-muted-foreground, var(--mantine-color-dimmed))",
  oddRowBackgroundColor: "var(--pulse-row-alt, transparent)",
  rowHoverColor: "var(--pulse-hover, rgba(128, 128, 128, 0.06))",
  selectedRowBackgroundColor:
    "var(--pulse-active-bg, rgba(128, 128, 128, 0.12))",
  borderColor: "var(--pulse-border, var(--mantine-color-default-border))",
  rowBorder: {
    color: "var(--pulse-border, var(--mantine-color-default-border))",
  },
  headerRowBorder: {
    color: "var(--pulse-border, var(--mantine-color-default-border))",
  },
  wrapperBorder: false,
  wrapperBorderRadius: 0,
  borderRadius: 4,
  headerColumnResizeHandleColor:
    "var(--pulse-border, var(--mantine-color-default-border))",
} as const;

/**
 * Base AG Grid theme (Quartz + terminal params) for grids that don't need
 * a scheme-aware hook.
 */
export const agGridThemeBase = themeQuartz.withParams(agGridThemeParams);

/**
 * Get color-scheme-specific AG Grid theme. Colors come from CSS vars, so only
 * browserColorScheme (native widgets/scrollbars) differs between schemes.
 */
export function getAgGridTheme(
  colorScheme: "dark" | "light",
  overrideParams?: Record<string, any>
): any {
  return themeQuartz.withParams({
    ...agGridThemeParams,
    browserColorScheme: colorScheme,
    ...overrideParams,
  });
}
